module.exports = __webpack_public_path__ + "static/media/drum-puh-lop.6ff64697.mp3";